// Generated by Melange

import * as Buhta_conf__Config from "../../conf/lib/Config.js";
import * as React from "react";

const context = React.createContext(Buhta_conf__Config.createEmptyState(undefined));

const make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

const Provider = {
  make: make,
  makeProps: makeProps
};

function useGlobalState(param) {
  return React.useContext(context);
}

function createGlobalStateContext(state) {
  return React.useState(function () {
      return state;
    })[0];
}

export {
  context,
  Provider,
  useGlobalState,
  createGlobalStateContext,
}
/* context Not a pure module */
